import type { AdapterMeta } from "@repo/adapter-core";

export const JELLIS_CRAIG_META: AdapterMeta = {
  slug: "jellis-craig",
  name: "Jellis Craig",
  baseUrl: "https://www.jelliscraig.com.au",
  description: "Premium inner Melbourne agency with sold property coverage across VIC.",
  supportedStates: ["VIC"],
  urlPattern: /jelliscraig\.com\.au\/property-details-[^/]+\/\d+/i,
  sourceType: "agency",
};
